import { Caption, css, styled } from 'canoe';

import { ValueInput } from '@candu-ai/craft/ui';

export const FieldsContainer = styled.div`
  flex-grow: 1;
`;

export const FieldRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    &:not(:first-of-type) {
      margin-top: ${theme.spaces.xxs};
    }
  `}
`;

export const FieldLabel = styled(Caption)`
  ${({ theme }) => css`
    width: 30px;
    margin: 0 ${theme.spaces.xs} 0 0;
  `}
`;

export const FieldInput = styled(ValueInput)`
  ${({ theme }) => css`
    min-width: 160px;
    height: 25px;
    background-color: ${theme.colors.GlitterGrayL20};
  `}
`;
